<template>
	
	<div class="ui grid">
		<div class="ui row stackable recordings-row">
			<div class="four wide column">
				<div class="ui vertical fluid menu" v-if="categories">
					<a :id="`_${item.id}`" class="item" v-for="item in categories" @click="openMainCategory(item)" :class="{'active teal': item == currentMainCategory}" :key="item.name">
						{{item.name | capitalize}}
					</a>
				</div>
			</div>
			<div class="twelve wide column" v-if="loading">
				<div class="ui segment">
					<div class="ui active centered inline loader"></div>
				</div>
			</div>
			<div class="twelve wide column" v-if="currentMainCategory && !loading">
                <category-tree :root-category="currentMainCategory" :userstatus="getuserStatus" :searchUrlParams="searchUrlParams"></category-tree>
			</div>
            <div class="twelve wide column" v-if="!loading && !currentMainCategory">
				<div class="ui segment">
			 		<p>Izberite predmet</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CategoryTree from './CategoryTree'

export default {
	components: {
        CategoryTree
	},
	props: ['userstatus'],
	data() {
		return {
            categories: undefined,
            currentMainCategory: undefined,
			loading: true,
			searchUrlParams: undefined
		};
	},
	mounted() {
		const urlSearchParams = new URLSearchParams(window.location.search);
		this.searchUrlParams = urlSearchParams.get('callbackParams') && (urlSearchParams.get('callbackParams') || "").split("-");
		this.getGroups();
	},
	computed: {
		getuserStatus() {
			return this.userstatus;
		}
	},
	methods: {
		getGroups() {			
			this.loadCategory().then(data => {
				this.categories = data.children
				if (this.searchUrlParams) { // odpiranje prve kategorije v primeru search url parametrov
					const paramId = this.searchUrlParams.shift();
					const categoryItem = (this.categories.filter(child => child.id == paramId) || [])[0];
					this.openMainCategory(categoryItem);
				} else { // default odpiranje prve kategorije po vrsti
					this.openMainCategory(this.categories[0]);
				}
			})

        },
        openMainCategory(item) {
			this.currentMainCategory = item
			
			if (!item.loaded) {
				this.loading = true
				this.loadCategory(item).then(() => {
					this.loading = false;
				})
			}
		},
		clickCategory(category) {
			return new Promise((resolve, reject) => {

			});
		},
		loadCategory(category) {

			return new Promise((resolve, reject) => {

				if (category == undefined) {
					this.loading = true
				} else {
					Vue.set(category, 'loading', true)
				}

				let route = category !== undefined ? this.route('dodatna-gradiva', category.id) : this.route('dodatna-gradiva')
				axios.get(route).then(({ data }) => {

					if (category === undefined) {
						this.loading = false
					} else {
						// make reactive
						Vue.set(category, 'additionalContent', data.additionalContent)
						Vue.set(category, 'children', data.children)
						Vue.set(category, 'loaded', true)

						Vue.delete(category, 'loading')
					}
					resolve(data)

				})

			})

		}
	},
    filters: {
        capitalize(text) {
            return text.charAt(0).toUpperCase() + text.slice(1)
        }
	},
	provide() {
		return {
			loadCategory: this.loadCategory
		}
	}
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/AdditionalContent.vue